
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Retroperitoneal_soft_tissue_sarcoma",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Retroperitoneal_soft_tissue_sarcoma.vue